import { useToast } from '@shared/context/ToastContext';
import { Toast } from './Toast';

export function ToastContainer() {
  const { toasts, removeToast } = useToast();

  if (toasts.length === 0) {
    return null;
  }

  return (
    <div
      className="pointer-events-none fixed bottom-0 right-0 z-50 flex flex-col gap-2 p-4"
      aria-label="Notificaciones"
    >
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          message={toast.message}
          severity={toast.severity}
          actionLabel={toast.actionLabel}
          onAction={toast.onAction}
          onClose={() => removeToast(toast.id)}
        />
      ))}
    </div>
  );
}
